import React from 'react';
import PropTypes from 'prop-types';
import * as Styled from './styles';

const Winner = ({ winnerName, winnerLocation }) => (
    <Styled.Wrapper>
        <Styled.WinnerName>Winner - {winnerName}</Styled.WinnerName>
        {winnerLocation && (
            <Styled.WinnerLocation>{winnerLocation}</Styled.WinnerLocation>
        )}
    </Styled.Wrapper>
);

Winner.defaultProps = {
    winnerLocation: ''
};

Winner.propTypes = {
    winnerName: PropTypes.string.isRequired,
    winnerLocation: PropTypes.string
};

export default Winner;
